import React, { useContext, useEffect, useState } from 'react';

import { Chip, Theme, useMediaQuery } from '@material-ui/core';
import ErrorIcon from '@material-ui/icons/ErrorOutline';

import { GlobalContext } from '../../../../../../store';
import { IEventEnrollment } from '../../../../../../store/admin/eventEnrollments/store';

import List from '../../../../../../components/Lists/List/List';
import { ResizeHandler } from '../../../../../../contrib/Hooks/useResizeHandler.hook';
import { filter } from '../../../TeeSheetCreator/Utils/filter';
import { filters } from '../../../TeeSheetCreator/Utils/filters';
import AddGuestPlayerPopOver from '../../../TeeSheetCreator/Components/AddGuestPlayerPopOver/AddGuestPlayerPopOver';
import { Input } from '../../../../../../components/Input';
import PlayerCard from '../../../../../../components/PlayerCard/PlayerCard';
import { TeamsCreatorPlayerSelectorStyled } from './TeamsCreatorPlayerSelector.Styles';
import { useTeamsCreatorDispatch, useTeamsCreatorState } from '../../Context/TeamsCreator.context';
import { useRouteInfoState } from '../../../../../../components/RouteInfo/Context/RouteInfo.context';
import { useAdminRound } from '../../../../../../contrib/Hooks/useAdminRound.hook';
import { useGetAdminEvent } from '../../../../../../contrib/Hooks/useGetAdminEvent';

export const TeamsCreatorPlayerSelector = () => {
  const {
    actions: {
      adminEventTeams: { update: updateAdminEventTeam }
    },
    adminEventTeams,
    adminEventEnrollments
  } = useContext(GlobalContext);

  const { clubId, eventId, roundId } = useRouteInfoState();

  const { editMode, selectedTeam } = useTeamsCreatorState();
  const { dispatch } = useTeamsCreatorDispatch();

  const event = useGetAdminEvent(eventId);
  const [round] = useAdminRound(roundId);

  const [availablePlayers, setAvailablePlayers] = useState<IEventEnrollment[]>([]);
  const [searchValue, setSearchValue] = useState('');
  const smUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('md'));

  const search = (evnt: any) => setSearchValue(evnt.target.value);

  useEffect(() => {
    const eventTeams = adminEventTeams[Number(eventId)];

    if (eventTeams && eventId && adminEventEnrollments[Number(eventId)]) {
      const teamedEnrollmentIds = eventTeams.reduce(
        (acc: number[], team) => [...acc, ...team.enrollments],
        []
      );

      setAvailablePlayers(
        adminEventEnrollments[Number(eventId)].filter(
          enrollment => !teamedEnrollmentIds.includes(enrollment.id)
        )
      );
    }
  }, [adminEventTeams, eventId, adminEventEnrollments]);

  const onAddPlayer = (enrollmentId: number) => async () => {
    if (selectedTeam) {
      const enrollments = [...selectedTeam.enrollments, enrollmentId];

      await updateAdminEventTeam(clubId, eventId, selectedTeam.id, {
        enrollments
      });

      dispatch({ type: 'setSelectedTeamEnrollments', value: enrollments });
    }
  };

  return (
    <TeamsCreatorPlayerSelectorStyled>
      {editMode &&
        selectedTeam &&
        event &&
        event.playersPerTeam &&
        selectedTeam.enrollments.length >= event.playersPerTeam &&
        !smUp && (
          <Chip
            className="full-team-chip"
            color="primary"
            variant="outlined"
            icon={<ErrorIcon />}
            label="This group is full"
          />
        )}

      <AddGuestPlayerPopOver />

      <Input
        id="player-lookup"
        label="PLAYER LOOKUP"
        onChange={search}
        outlined={true}
        placeholder="PLAYER LOOKUP"
        type="search"
        value={searchValue}
      />

      <ResizeHandler>
        {() => (
          <List
            items={availablePlayers}
            renderItem={PlayerCard}
            filters={filters}
            customFilter={filter(searchValue)}
            context={{
              onAddClick:
                editMode &&
                selectedTeam &&
                event &&
                selectedTeam.enrollments.length < (event.playersPerTeam || 2)
                  ? onAddPlayer
                  : undefined,
              round
            }}
          />
        )}
      </ResizeHandler>
    </TeamsCreatorPlayerSelectorStyled>
  );
};
